import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-comicstripe',
  templateUrl: './comicstripe.component.html',
  styleUrls: ['./comicstripe.component.css']
})
export class ComicstripeComponent implements OnInit {
  public play:boolean=true;
  public audio = new Audio();
  public mutedButton = 'volume_up';

  constructor() { 
    this.audio.src = "./assets/sounds/soundtrack.mp3";    
    this.audio.load();
  }

  playPause(){
    if(this.play){
      this.audio.play();
    } else {
      this.audio.pause();   
    }
    this.play = !this.play;
  }

  muteUnmute(){
    this.audio.muted = !this.audio.muted;
    this.mutedButton = this.audio.muted? 'volume_off' : 'volume_up';
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/Users/bompadre/Documents/angular2/myapp2/src/app/widgets/comicstripe/comicstripe.component.ts